module.exports = __webpack_public_path__ + "static/media/Preisliste Selbstzahler.1ade0a07.pdf";